import moment from 'moment';

export function getFallbackMomentLocale(): string {
  const browserLocale = navigator.language;
  // Check if the browser locale is supported by moment,
  // if not fallback to the language without the extra character (ex: en-GB-ext -> en-gb),
  // if that is also not supported fallback to English
  const momentLocale =
    moment.locales().find((l) => l === browserLocale.toLowerCase()) ??
    moment.locales().find((l) => l === browserLocale.toLowerCase().match(/^[a-z]+-[a-z]+/)?.[0]) ??
    'en';
  return momentLocale;
}
